import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { ENTITY_JURISDICTIONS_RESET } from './entityJurisdictions.const';
import entityJurisdictionsDetail from './entityJurisdictionsDetail/entityJurisdictionsDetail.reducer';
import registrationsListReducer from './entityJurisdictionsList/entityJurisdictionsList.reducer';

const initialState = {};

const combinedReducers = combineReducers({
  detail: entityJurisdictionsDetail,
  list: registrationsListReducer,
});

const entityJurisdictionsRootReducer = createReducer(initialState, builder => {
  builder.addCase(ENTITY_JURISDICTIONS_RESET, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action) => {
  const newState = entityJurisdictionsRootReducer(state, action);
  return combinedReducers(newState, action);
};
